import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, Phone, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { useSite } from '../context/SiteContext';

const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Buy', to: '/properties/for-sale', dropdown: [
    { label: 'House for Sale', to: '/properties/for-sale/house' },
    { label: 'Condominium for Sale', to: '/properties/for-sale/condominium' },
    { label: 'Land for Sale', to: '/properties/for-sale/land' },
    { label: 'Commercial for Sale', to: '/properties/for-sale/commercial' }
  ]},
  { label: 'Rent', to: '/properties/for-rent', dropdown: [
    { label: 'House for Rent', to: '/properties/for-rent/house' },
    { label: 'Condominium for Rent', to: '/properties/for-rent/condominium' },
    { label: 'Commercial for Rent', to: '/properties/for-rent/commercial' }
  ]},
  { label: 'Advisors', to: '/agents' },
  { label: 'Blog', to: '/blog' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [activeDrop, setActiveDrop] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const { settings } = useSite();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const company = {
    name: settings?.companyName || 'Terra Homes Realty',
    tagline: settings?.tagline || 'Your Home, Our Goal',
    mobile: settings?.mobile || '+63 917 815 0888',
    email: settings?.email || 'info@terrahomes.ph',
    logo: settings?.logo || '/assets/logo.png'
  };

  return (
    <header className={'sticky top-0 z-50 bg-white transition-shadow duration-300 ' + (scrolled ? 'shadow-lg border-b border-neutral-100' : 'shadow-sm border-b border-neutral-200')}>
      <div className="hidden md:flex bg-neutral-900 text-neutral-200 text-xs">
        <div className="max-w-7xl mx-auto w-full px-6 py-2 flex justify-between items-center">
          <span>Welcome to {company.name} {'\u2014'} {company.tagline}</span>
          <div className="flex items-center gap-4">
            <a href={'tel:' + company.mobile} className="flex items-center gap-1 hover:text-white"><Phone className="w-3 h-3" /> {company.mobile}</a>
            <a href={'mailto:' + company.email} className="hover:text-white">{company.email}</a>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src={company.logo} alt={company.name} className="h-12 md:h-14 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((item) => (
            <div
              key={item.label}
              className="relative"
              onMouseEnter={() => item.dropdown && setActiveDrop(item.label)}
              onMouseLeave={() => setActiveDrop(null)}
            >
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({isActive}) =>
                  'px-3 py-2 text-sm font-medium rounded-md flex items-center gap-1 transition-colors ' +
                  (isActive ? 'text-[#DC2626]' : 'text-neutral-800 hover:text-[#DC2626]')
                }
              >
                {item.label}
                {item.dropdown && <ChevronDown className="w-3 h-3" />}
              </NavLink>
              {item.dropdown && activeDrop === item.label && (
                <div className="absolute left-0 top-full pt-1 w-60 z-50">
                  <div className="bg-white border border-neutral-200 rounded-md shadow-lg py-2">
                    {item.dropdown.map((d) => (
                      <Link key={d.to} to={d.to} className="block px-4 py-2 text-sm text-neutral-700 hover:bg-red-50 hover:text-[#DC2626]">{d.label}</Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <Link to="/contact">
            <Button className="btn-primary rounded-md">List Your Property</Button>
          </Link>
        </div>

        <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-neutral-800" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-neutral-200 bg-white">
          <div className="px-4 py-2 flex flex-col">
            {NAV.map((item) => (
              <Link key={item.label} to={item.to} onClick={() => setOpen(false)} className="py-3 border-b border-neutral-100 text-neutral-800 font-medium">{item.label}</Link>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)} className="mt-3 mb-2">
              <Button className="btn-primary w-full rounded-md">List Your Property</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
